/**
 * Приоритет обращения. Чем меньше число, тем выше приоритет.
 * Зеркало app/Enums/RequestPriorityType.php.
 */
export default class RequestPriorityType {
    static CRITICAL = 1;
    static HIGH = 2;
    static NORMAL = 3;
    static LOW = 4;

    static values() {
        return [this.CRITICAL, this.HIGH, this.NORMAL, this.LOW];
    }
}
